<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 13</h1>
          <div class="text-left">
            <p>Natural History Museum</p>
            <a href="/uk/13Natural.jpeg"><img alt="London" class="uitk-image-media" src="13Natural.jpeg" style="width: 17%; height: auto;"></a>       
            <a href="/uk/13Natural2.jpeg"><img alt="London" class="uitk-image-media" src="13Natural2.jpeg" style="width: 17%; height: auto;"></a>       
            <a href="/uk/13Natural3.jpeg"><img alt="London" class="uitk-image-media" src="13Natural3.jpeg" style="width: 17%; height: auto;"></a>       
            <a href="/uk/13Natural4.jpeg"><img alt="London" class="uitk-image-media" src="13Natural4.jpeg" style="width: 17%; height: auto;"></a>       
            <a href="/uk/13Natural5.jpeg"><img alt="London" class="uitk-image-media" src="13Natural5.jpeg" style="width: 17%; height: auto;"></a>       
            <p>No matter how many times I tell Frank to get out of my shot he is always in it</p>
            <a href="/uk/13Frank.jpeg"><img alt="Frank Photo Bomb" class="uitk-image-media" src="13Frank.jpeg" style="width: 17%; height: auto;"></a>          
            <p>Science Museum</p>
            <a href="/uk/13Science.jpeg"><img alt="Science Museum" class="uitk-image-media" src="13Science.jpeg" style="width: 17%; height: auto;"></a>          
            <a href="/uk/13Science2.jpeg"><img alt="Science Museum" class="uitk-image-media" src="13Science2.jpeg" style="width: 17%; height: auto;"></a>          
            <p>Harrods Fish & Chips for the rich people</p>
            <a href="/uk/13Harrods.jpeg"><img alt="Science Museum" class="uitk-image-media" src="13Harrods.jpeg" style="width: 17%; height: auto;"></a>          
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>